



































import {Component, Vue, Watch} from "vue-property-decorator";
import {State} from "vuex-class";
import {CrucigramaListInterface, PalabraInterface} from "@/models/Crucigrama";


// Objeto default para celdas vacías de la grilla
const empty: { words: any[]; start?: any; letter?: any; empty?: any } = {
    start: false,
    letter: '',
    words: [] as any[],
    empty: true
};

@Component
export default class Crucigrama extends Vue{

    @State(state => state.game.crucigramaList) crucigramas: CrucigramaListInterface[];

    public level = 1;




    // Arreglo de booleanos indicando si una palabra fue completada
    completed: boolean[] = [];
    // Entero indicando la palabra que fue seleccionada para completar
    public selected: any  = null;
    // String donde se guarda lo que ingresa el usuario
    answer = '';
    // Cantidad de veces que se solicitó una pista
    penalties = 0;
    // Temporizador en segundos desde el comienzo de la partida. Comienza en 5 minutos.
    timer = 60 * 5;
    // La tabla que será armada al inicio; conteniendo todas las celdas
    matrix: any[] = [];
    // Mensaje final a mostrar
    public mensaje: any | undefined = null;

    get pista () {
        if (this.selected === null) return null;
        return `${this.palabras[this.selected].sentido ? 'Vertical' : 'Horizontal'} ${this.selected + 1}: ${this.palabras[this.selected].pista}`
    }
    // Formato a mostrar del cronómetro


    get palabras(): PalabraInterface[]{
        return this.$store.getters.crucigramaById( this.crucigramas[this.level -1].id )
    }

    dibujarTable(){
        // Creación de la tabla que contiene las celdas.

        const matrix = Array(9).fill(0).map(() => Array(8).fill(null).map(() => empty));
        this.palabras.forEach((palabra, index) => {
            const [x, y] = palabra.pos;
            palabra.palabra.split('').forEach((l, i) => {
                let cell: any = matrix[y + (palabra.sentido ? i : 0)][x + (palabra.sentido ? 0 : i)];
                if (cell === empty) {
                    cell = matrix[y + (palabra.sentido ? i : 0)][x + (palabra.sentido ? 0 : i)] = {words: []}
                }
                cell.empty = false
                cell.words.push(index)
                if (i === 0) {
                    cell.start = index + 1
                }
                cell.letter = l
            })
        });
        this.matrix = matrix;
    }


    restart(){
        this.level = 1;
        this.completed = Array(this.palabras.length).fill(false);

        this.dibujarTable()
    }

    siguiente(){
        this.level++

        this.completed = Array(this.palabras.length).fill(false);

        this.dibujarTable()

    }

    created () {
        this.$store.watch((state, getters) => state.game.crucigrama,
            (value, oldValue) => {
                this.completed = Array(this.palabras.length).fill(false);

                this.dibujarTable();
            });

        this.$store.dispatch('bindCrucigramaList', 'asc');
        this.$store.dispatch('bindCrucigrama', 'asc');



    }

    selectWord (index: number) {
        if (index > 0) {
            this.selected = index - 1;
            this.answer = '';
            // @ts-ignore
            setTimeout(() => this.$refs.input.focus(), 50)
        }
    }
    // Se fija si la palabra ingresada es correcta y de ser así, modifica el arreglo de palabras completas
    corregir () {
        const solucion = this.palabras[this.selected].palabra;
        const answer = this.answer.toLowerCase();
        if (answer === solucion) {
            this.completed[this.selected] = true;
            this.selected = null
        }
    }
    // Agrega una letra correcta más a la respuesta actual
    solucion () {
        const solucion = this.palabras[this.selected].palabra;
        const answer = this.answer.toLowerCase();
        if (answer === solucion) {
            return
        }
        if (answer !== solucion.slice(0, answer.length)) {
            this.penalties++
            this.answer = ''
        }
        this.answer = solucion.slice(0, this.answer.length + 1);
        this.penalties++
    }
    // Calcula el puntaje final del jugador en base a las respuestas correctas y las penalidades por pistas
    finalizar () {
        const total = this.completed.reduce((total, current, i) => total + this.palabras[i].palabra.length, 0);
        const completo = this.completed.reduce((total, current, i) => current ? total + this.palabras[i].palabra.length : total, 0);
        const tempScore = Math.ceil(100 * completo / total);
        const finalScore = Math.max(tempScore - this.penalties, 0);
        if (tempScore < 100) {
            this.penalties++
        }
        this.mensaje = `
    Tu puntuación es ${finalScore}%.
  `
    }

}
